// extracted by mini-css-extract-plugin
export var errorIcon = "_po-1";
export var nameLogo = "_po-0";